// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"20c6466247fa37a5735c","532":"eeeb7e74c318c5d17d5c","678":"5c0e7ede91dff9b7a3eb","883":"b0b1ab6b163028647cfa"}[chunkId] + ".js";
};